import React from "react";

import styles from "./BlockPreviewModal.module.scss";

import i18n from "../../../../constants/i18n";
import {
    getBlockTitle,
    getBlockHeaderClassName,
} from "../../../../helpers/blockHelpers";
import blockTypes from "../../../../constants/blockTypes";
import ShowIf from "../../../ShowIf";

const BlockPreviewModalView = ({
    activeBlockIndex,
    block,
    blockArrayLength,
    disableNextBlockButton,
    disablePrevBlockButton,
    isVisible,
    onNextBlockRequest,
    onPrevBlockRequest,
    preview,
    onCloseButtonClick,
}) => {
    const blocksLength = [...Array(blockArrayLength).keys()];
    const failedPhotos = (block.photos || []).filter(
        (photo) => photo?.processingFailure
    );

    return (
        <div className={`modal ${isVisible ? "is-active" : ""}`}>
            <div className="modal-background" />
            <div className={`modal-card ${styles.modalCard}`}>
                <header className="modal-card-head">
                    <h2 className="modal-card-title has-text-primary">
                        {i18n.previewModal.title}
                    </h2>
                    <button
                        onClick={onCloseButtonClick}
                        className="delete"
                        aria-label="close"
                    />
                </header>
                <section className="modal-card-body">
                    <div className={styles.header}>
                        <div className={styles.box}>
                            <div
                                onClick={onPrevBlockRequest}
                                className={`${styles.arrowButton} ${
                                    disablePrevBlockButton
                                        ? styles.disabled
                                        : ""
                                }`}
                            >
                                <span className={`icon ${styles.arrowCircle}`}>
                                    <i className="fas fa-chevron-left"></i>
                                </span>
                                <span>{i18n.previewModal.previous}</span>
                            </div>
                        </div>
                        <div className={styles.box}>
                            <div
                                className={`${
                                    styles.block
                                } ${getBlockHeaderClassName(block, styles)}`}
                            >
                                <span>{getBlockTitle(block)} </span>
                                <ShowIf
                                    condition={
                                        block.manualImageControl &&
                                        block.type === blockTypes.SPEAKER
                                    }
                                >
                                    <span>
                                        <i
                                            className="fas fa-magic"
                                            title={
                                                i18n.manualImageControl
                                                    .hoverText
                                            }
                                        />
                                    </span>
                                </ShowIf>
                            </div>
                        </div>
                        <div className={styles.box}>
                            <div
                                onClick={onNextBlockRequest}
                                className={`${styles.arrowButton} ${
                                    disableNextBlockButton
                                        ? styles.disabled
                                        : ""
                                }`}
                            >
                                <span className={`icon ${styles.arrowCircle}`}>
                                    <i className="fas fa-chevron-right"></i>
                                </span>
                                <span>{i18n.previewModal.next}</span>
                            </div>
                        </div>
                        <div className={styles.fullWidth}>
                            <ShowIf
                                condition={
                                    block.manualImageControl &&
                                    block.type === blockTypes.SPEAKER
                                }
                            >
                                <span>{i18n.manualImageControl.hoverText}</span>
                            </ShowIf>
                        </div>
                    </div>
                    <ShowIf condition={failedPhotos.length > 0}>
                        <div className={styles.processingFailureWarning}>
                            <span className="icon has-text-danger is-medium">
                                <i className="fas fa-times-circle"></i>
                            </span>
                            <div>
                                <strong>
                                    {
                                        i18n.previewModal
                                            .processingFailureWarning
                                    }
                                </strong>
                                <ul>
                                    {failedPhotos.map((photo) => (
                                        <li key={photo.id}>
                                            {i18n.generic.processingFailureMessage.replace(
                                                "<FILENAME>",
                                                photo.originalFileName || ""
                                            )}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </ShowIf>
                    <div className={styles.iframeContainer}>
                        {preview ? (
                            <iframe src={preview.url} title="preview"></iframe>
                        ) : null}
                    </div>
                    <div className={styles.steps}>
                        {blocksLength.map((_, index) => (
                            <div
                                key={index}
                                className={`${styles.step} ${
                                    index === activeBlockIndex
                                        ? styles.active
                                        : ""
                                }`}
                            ></div>
                        ))}
                    </div>
                </section>
                <footer className="modal-card-foot"></footer>
            </div>
        </div>
    );
};

export default BlockPreviewModalView;
